import {useState, useEffect} from 'react'

// @mui material components
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import TextField from "@mui/material/TextField"
import FormControl from "@mui/material/FormControl"

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import ModalDialog from "components/ModalDialog/ModalDialog";

// Material Dashboard 2 React example components
import Footer from "examples/Footer";
import DataTable from "examples/Tables/DataTable";

// Data
import OffersTableData from "layouts/tables/data/offersTableData";
import ModalOfferData from "layouts/tables/data/modalOfferData"

import {searchBoxStyle} from "./styles/searchbox_style"

import { useTokenContext } from 'App';
import { getOffers } from 'api/offer/getOffers';
import {getPhotoSource} from "api/requests"
import DashboardLayout from 'examples/LayoutContainers/DashboardLayout';
import DashboardNavbar from 'examples/Navbars/DashboardNavbar';

import {readStream} from "readStream/readStream"

function Offers() {
  const [searchText, setSearchText] = useState('');
  const [indexPage, setIndexPage] = useState(0)
  const {token} = useTokenContext();
  const [offersResponse, setOffersResponse] = useState(null);
  const [offer, setOffer] = useState(null)
  const [myStorage, setMyStorage] = useState({})
  const [closeCancelResponse, setCloseCancelResponse] = useState(null)
  const [nrPhotosDownloaded, setNrPhotosDownloaded] = useState(0)
  const { columns: columnOffers, rows: rowOffers} = OffersTableData(onActionClick, searchText, offersResponse , myStorage, token);


  function onActionClick(offer){
    setOffer(offer)
    setShowModal(true);
  }

  const onCloseModalClick = () =>{
    setShowModal(false);
  }

  const handleTextChange = (event) => {
    setSearchText(event.target.value);
  };

  const handleIndexPage = (index) => {
    setIndexPage(index)
  }

  const [showModal, setShowModal] = useState(false)
  const modalData = <ModalOfferData offer={offer}/>

  const doGetOffers = async () => {
    try {
      const offersResponse = await getOffers(token);
      setOffersResponse(offersResponse)

    } catch (error) {
      console.error("Error on get offers: ", error);
    }
  }


  useEffect(() => {
    if(offersResponse){
      if('offers' in offersResponse['data']){
        for(var i=0; i < offersResponse["data"]['offers'].length; i++){
          const avatarPhotoId = offersResponse['data']['offers'][i]['avatar']['photo_id']
          const productPhotoId = offersResponse['data']['offers'][i]['product']['product_photos_ids'][0]
          if(localStorage.getItem(avatarPhotoId) === null){
            getPhotoSource(avatarPhotoId, token)
            .then(response => {
              const reader = response.body.getReader();
              readStream(reader)
              .then(base64Response => {
                localStorage.setItem(avatarPhotoId, base64Response)
                setNrPhotosDownloaded(nr => nr+1)
              })
              
            })
          }
          if(localStorage.getItem(productPhotoId) === null){
            getPhotoSource(productPhotoId, token)
            .then(response => {
              const reader = response.body.getReader();
              readStream(reader)
              .then(base64Response => {
                localStorage.setItem(productPhotoId, base64Response)
                setNrPhotosDownloaded(nr => nr+1)
              })
              
            })
          }
        }
      }
    }
  }, [offersResponse, token]);

  
  useEffect(() => {
    doGetOffers();
  },[]);

  useEffect(() => {
    const interval = setInterval(() => {
      doGetOffers();
    }, 5000);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    if(closeCancelResponse){
      doGetOffers();
      setShowModal(false)
      setCloseCancelResponse(null);
    }
  }, [closeCancelResponse]);

  useEffect(() => {
    setMyStorage(localStorage)
  }, [nrPhotosDownloaded])

  return (
    <>
    {(columnOffers && rowOffers) && (
    <>
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={2} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
              <MDBox sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                <FormControl sx={{ m: 1, width: '40ch' }}>
                  <TextField fullWidth label="Search offer code..." onChange={handleTextChange} InputLabelProps={searchBoxStyle.placeholder} sx={[searchBoxStyle.text, searchBoxStyle.border]} variant="outlined" />
                </FormControl>
              </MDBox>
          </Grid>
          <Grid item xs={12}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={3}
                px={2}
                variant="gradient"
                bgColor="info"
                borderRadius="lg"
                coloredShadow="info"
                sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}
                >
                  <MDTypography variant="h6" color="white">
                    Offers
                  </MDTypography>
              </MDBox>
              <MDBox pt={3}>
                <DataTable
                  table={{ columns: columnOffers, rows: rowOffers }}
                  isSorted={false}
                  canSearch={true}
                  entriesPerPage={false}
                  showTotalEntries={false}
                  handleIndexPage={handleIndexPage}
                  indexPage={indexPage}
                  visibleHead={true}
                  noEndBorder
                />
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      <Footer />
    </DashboardLayout>
    {showModal &&
      <ModalDialog 
        onCloseModalClick={onCloseModalClick} 
        title="View Deal" 
        content={modalData}
      />
    }
    </>
    )}
    </>
  );
}

export default Offers;
